import * as React from 'react';
import Badge from '@mui/material/Badge';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import AppContentModal from './AppContentModal';
import { styled } from '@mui/material/styles';
import { useNavigate } from "react-router-dom";
import { model } from '../config/config';

export default function ColorBadge(props) {
    
    const StyledBadge = styled(Badge)(({ theme }) => ({
        '& .MuiBadge-badge': {
            right: 125,
            top: 20,
            padding: '2px 8px',
            borderRadius: '6px',
            borderBottom: '6px',
        },
    }));
	
	let wfheight = 0;
	if( model.includes("gts") || model.includes("bip") || model === "active")
	{
		wfheight = 225;
	}else if( model.includes("amazx") || model.includes("aband7"))
	{
		wfheight = 250;
	}else{
		wfheight = 180;
	}
	
	const navigate=useNavigate();
	const goToCarddetails = (cardId) => {
		localStorage.setItem("selectedAppCard", JSON.stringify(cardId));
		localStorage.setItem("filetype", props.binfile);
		navigate(`/${model}/apps/${props.fileid}`);	
		 window.scroll(0, 0);
	}
	
    return (
        <div onClick = {()=>goToCarddetails(props)}>
            <StyledBadge>
                <Card sx={{ width: 180 }}>
                    <CardActionArea sx={{ backgroundColor: "none" }}>
                        <CardMedia
                            component="img"
						   
                            image={ props.imgurl }
                            alt="green iguana"
							sx={{ objectFit: 'contain', height: wfheight }}
                        />
                        <CardContent sx={{ p: 1 }} title={props.name}>
                            <Typography gutterBottom variant="subtitle1" component="div" noWrap={true} textAlign="center">
                                <span>{props.name}</span>
                            </Typography>
                            <Typography variant="body2" color="text.secondary" textAlign="center">
                                {props.author}
                            </Typography>
                        </CardContent>
                    </CardActionArea>
                </Card>
            </StyledBadge>
        </div>
    );
}